<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">person_search</i>
            </div>
            <h4 class="card-title">
              {{ isViewOnly ? "View" : id ? "Update" : "New" }} Prospect
            </h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="campaignId"
                      >Campaign</label
                    >
                    <select
                      class="form-control"
                      id="campaignId"
                      formControlName="campaignId"
                    >
                      <option value="">Select Campaign</option>
                      <option *ngFor="let camp of campaigns" [value]="camp._id">
                        {{ camp.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="prospectName"
                      >Prospect Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="prospectName"
                      formControlName="prospectName"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="domain"
                      >Domain</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="domain"
                      formControlName="domain"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="sourceUrl"
                      >Source URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="sourceUrl"
                      formControlName="sourceUrl"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="prospectType"
                      >Prospect Type</label
                    >
                    <select
                      class="form-control"
                      id="prospectType"
                      formControlName="prospectType"
                    >
                      <option value="">Select Type</option>
                      <option
                        *ngFor="let type of prospectTypes"
                        [value]="type.value"
                      >
                        {{ type.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="country"
                      >Country</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="country"
                      formControlName="country"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="relevanceScore"
                      >Relevance Score</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="relevanceScore"
                      formControlName="relevanceScore"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="authorityScore"
                      >Authority Score</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="authorityScore"
                      formControlName="authorityScore"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="trustScore"
                      >Trust Score</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="trustScore"
                      formControlName="trustScore"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="spamRisk"
                      >Spam Risk</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="spamRisk"
                      formControlName="spamRisk"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="contactName"
                      >Contact Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="contactName"
                      formControlName="contactName"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="contactEmail"
                      >Contact Email</label
                    >
                    <input
                      type="email"
                      class="form-control"
                      id="contactEmail"
                      formControlName="contactEmail"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="contactFormUrl"
                      >Contact Form URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="contactFormUrl"
                      formControlName="contactFormUrl"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="outreachStatus"
                      >Outreach Status</label
                    >
                    <select
                      class="form-control"
                      id="outreachStatus"
                      formControlName="outreachStatus"
                    >
                      <option
                        *ngFor="let s of outreachStatuses"
                        [value]="s.value"
                      >
                        {{ s.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="outreachChannel"
                      >Outreach Channel</label
                    >
                    <select
                      class="form-control"
                      id="outreachChannel"
                      formControlName="outreachChannel"
                    >
                      <option
                        *ngFor="let c of outreachChannels"
                        [value]="c.value"
                      >
                        {{ c.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="followUpAt"
                      >Follow Up Date</label
                    >
                    <input
                      type="date"
                      class="form-control"
                      id="followUpAt"
                      formControlName="followUpAt"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetUrl"
                      >Target URL</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetUrl"
                      formControlName="targetUrl"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="targetKeyword"
                      >Target Keyword</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="targetKeyword"
                      formControlName="targetKeyword"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="suggestedAnchor"
                      >Suggested Anchor</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="suggestedAnchor"
                      formControlName="suggestedAnchor"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="notes">Notes</label>
                    <textarea
                      class="form-control"
                      id="notes"
                      formControlName="notes"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-secondary mr-2"
                    (click)="goBack()"
                  >
                    Back
                  </button>
                  <button
                    *ngIf="!isViewOnly"
                    type="submit"
                    class="btn btn-dark"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
